import BasicModel from '../basic/BasicModel'
export default {
  selectDistributorAccount (vm, params, listener) {
    let action = 'distributor/selectDistributorAccount.action'
    BasicModel.get(vm, action, params, listener)
  },
  findDbtServiceConsumeRecordStatistics (vm, params, listener) {
    let action = 'distributor/findDbtServiceConsumeRecordStatistics.action'
    BasicModel.get(vm, action, params, listener)
  },
  findDbtThirdPartyToolsConsumeRecordStatistics (vm, params, listener) {
    let action = 'distributor/findDbtThirdPartyToolsConsumeRecordStatistics.action'
    BasicModel.get(vm, action, params, listener)
  },
  getDistributorIndex (vm, params, listener) {
    let action = 'distributor/getDistributorIndex.action'
    BasicModel.get(vm, action, params, listener)
  },

  selectWeChatMchInfo (vm, params, listener) {
    let action = 'withdrawAccount/selectWeChatMchInfo.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectPlatIncomeList (vm, params, listener) {
    let action = 'distributor/selectPlatIncomeList.action'
    BasicModel.get(vm, action, params, listener)
  }
}
